import CoreApiService from "../../system/api/coreApiService"
import {INews2User } from '../../libs/coreapi-dto/service/newsChat';
import News2UserRequest from "../../libs/core-api-requests/dirs/news2UserRequest";

export class News2UserDataProvider {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }
    getDataRequest(): Promise<News2UserRequest> {
        return this._coreApiService.news2UserRequest;
    }

    postNews2User(body: INews2User, callback: (id: string) => void) {
        this.getDataRequest()
            .then(r => r.postNews2User(body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'NewsChatDataProvider upsert !isCompleted');
            },))
    }
}